import { CheckItemAction, ECheckItemActionTypes, ICheckItemState } from './../../types/redux/checkItem'

const initialState: ICheckItemState = {
	active: false,
	itemId: 0,
	itemName: '',
}

export const checkItemReducer = (state: ICheckItemState = initialState, action: CheckItemAction): ICheckItemState => {
	switch (action.type) {
		case ECheckItemActionTypes.SHOW_CHECK_ITEM:
			return {
				active: true,
				itemId: action.payload.id,
				itemName: action.payload.name,
			}
		case ECheckItemActionTypes.CLOSE_CHECK_ITEM:
			return {
				active: false,
				itemId: 0,
				itemName: '',
			}
		default:
			return state
	}
}
